export default __webpack_public_path__ + "static/media/section1-bg.39455d4c.png";